import useLanguage from "@casino/legacy/client/hooks/useLanguage";
import { useRequestEmailVerificationMutation } from "@workspace/casino_core/mutations/RequestEmailVerificationMutation.client";

const useRequestEmailVerification = () => {
  const { code: language } = useLanguage();
  const [requestEmailVerificationMut] = useRequestEmailVerificationMutation();
  const requestEmailVerification = async () =>
    requestEmailVerificationMut({
      input: {
        language,
        linkDomain: location.hostname,
      },
    });
  return { requestEmailVerification };
};

export default useRequestEmailVerification;
